/*
 * Build flags for brand signup + "My newsletters" (design
 * MY-DESIGN-BRAND-SIGNUP-AND-COMPLETE-PROFILE-1020 §8; row
 * _design/DESIGN-BRAND-SIGNUP-AND-NEWSLETTERS-V1). Same shape as
 * ticketCreditsEnabled / transferEnabled:
 *
 *   VITE_BRAND_SIGNUP_ENABLED === 'true' → the public /join/:slug form, the
 *     authed /join/confirm landing and the Profile "My newsletters" section
 *     exist. Absent or anything else = OFF: the routes don't exist (they fall
 *     through to normal routing) and the section is hidden.
 *   VITE_TURNSTILE_SITE_KEY → the Cloudflare Turnstile site key (public).
 *     Unset ⇒ the join form shows its "not available" state with submit
 *     disabled (my-api refuses a signup without a Turnstile token).
 *
 * The env is injectable so tests can pin both sides.
 */
export function brandSignupEnabled(env: Record<string, string | undefined> = import.meta.env): boolean {
  return env.VITE_BRAND_SIGNUP_ENABLED === 'true'
}

/** VITE_MY_NEWSLETTERS_ENABLED === 'true' → the Profile "My newsletters"
 *  section (its own flag: newsletters ships before /join, boardroom
 *  2026-10-20). Absent or anything else = hidden, no request. */
export function newslettersEnabled(env: Record<string, string | undefined> = import.meta.env): boolean {
  return env.VITE_MY_NEWSLETTERS_ENABLED === 'true'
}

export function turnstileSiteKey(env: Record<string, string | undefined> = import.meta.env): string | null {
  const k = env.VITE_TURNSTILE_SITE_KEY?.trim()
  return k ? k : null
}
